export function toLowerCase(str) {
    return String(str).toLowerCase();
}

export function prefixChar(str, char, digits) {
    return String(str).padStart(digits, char);
}

export function appendQueryStr2Str(str, queryString) {
    str = String(str);
    if (!queryString) {
        return str;
    } else if (str.indexOf('?') > -1) {
        return `${str}&${queryString}`;
    } else {
        return `${str}?${queryString}`;
    }
}

/**
 * 移除字串中的所有 HTML 標籤，只保留純文字內容
 * @param {string} htmlString - 包含 HTML 標籤的字串
 * @returns {string} 移除 HTML 標籤後的純文字
 */
export function stripHtmlTags(htmlString) {
    if (!htmlString || typeof htmlString !== 'string') {
        return '';
    }
    return htmlString.replace(/<[^>]*>/g, '');
}
